export interface TableColumn {
    id: string;
    pretty_name: string;
    width: number;
}

export interface InvoiceColumnsParams {
    consignmentReferenceNumber?: string;
    parentReferenceNumber?: string;
}

export interface PieceAndEwbDetailsColumnsParams {
    consignmentReferenceNumber?: string;
    parentReferenceNumber?: string;
}

export const getInvoiceColumns = (params: InvoiceColumnsParams): TableColumn[] => {
    const {
        consignmentReferenceNumber,
        parentReferenceNumber,
    } = params;
    const columnsToReturn: TableColumn[] = [
        {
            id: 'invoice_number',
            pretty_name: 'Invoice Number',
            width: 150,
        },
        {
            id: 'invoice_status',
            pretty_name: 'Invoice Status',
            width: 150,
        },
        {
            id: 'invoice_date',
            pretty_name: 'Invoice Date',
            width: 150,
        },
        {
            id: 'proof_image_list',
            pretty_name: 'Proof Image List',
            width: 150,
        },
        {
            id: 'amount',
            pretty_name: 'Amount',
            width: 100,
        },
        {
            id: 'ewb_number',
            pretty_name: 'EWB Number',
            width: 150,
        },
        {
            id: 'sender_gstin',
            pretty_name: 'Sender GSTIN',
            width: 150,
        },
        {
            id: 'receiver_gstin',
            pretty_name: 'Receiver GSTIN',
            width: 150,
        },
        {
            id: 'ewb_creation_time',
            pretty_name: 'EWB Creation Time',
            width: 150,
        },
        {
            id: 'ewb_expiry_time',
            pretty_name: 'EWB Expiry Time',
            width: 150,
        },
        {
            id: 'transporter_gstin',
            pretty_name: 'Transporter GSTIN',
            width: 150,
        },
        {
            id: 'transporter_name',
            pretty_name: 'Transporter Name',
            width: 150,
        },
    ];
    if (
        !consignmentReferenceNumber ||
        !parentReferenceNumber ||
        consignmentReferenceNumber === parentReferenceNumber
    ) {
        columnsToReturn.splice(1, 0, {
            id: 'piece_reference_number',
            pretty_name: 'Pieces',
            width: 100,
        });
    }
    return columnsToReturn;
};

export const getPieceAndEwbDetailsColumns = (
    params: PieceAndEwbDetailsColumnsParams,
): TableColumn[] => {
    const {
        consignmentReferenceNumber,
        parentReferenceNumber,
    } = params;
    const columnsToReturn: TableColumn[] = [
        {
            id: 's_no',
            pretty_name: 'S.No.',
            width: 50,
        },
        {
            id: 'ewb_number',
            pretty_name: 'EWB Number',
            width: 100,
        },
    ];
    if (
        !consignmentReferenceNumber ||
        !parentReferenceNumber ||
        consignmentReferenceNumber === parentReferenceNumber
    ) {
        columnsToReturn.splice(1, 0, {
            id: 'piece_reference_number',
            pretty_name: 'Piece Reference Number',
            width: 100,
        });
    }
    return columnsToReturn;
};
